import { Link } from "react-router-dom";
import { Check, Clock } from "lucide-react";
import { fileUrl, rupiah } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ProviderLogo } from "@/components/ProviderCard";

export const PackageCard = ({ pkg, showProvider, canBook = true }) => (
  <div className="card-soft flex flex-col overflow-hidden" data-testid={`package-card-${pkg.package_id}`}>
    {pkg.photo_path && <img src={fileUrl(pkg.photo_path)} alt="" className="h-36 w-full object-cover" loading="lazy" />}
    <div className="flex flex-1 flex-col p-5">
      {showProvider && pkg.provider && (
        <Link to={`/penyedia/${pkg.provider.slug}`} className="mb-3 flex items-center gap-2 text-xs font-semibold text-stone-600 hover:text-teal-800">
          <ProviderLogo provider={pkg.provider} size="h-6 w-6" /> {pkg.provider.business_name}
        </Link>
      )}
      <p className="text-xs font-medium text-teal-700">{pkg.subcategory_name}</p>
      <h3 className="mt-1 font-bold text-stone-900" data-testid={`package-title-${pkg.package_id}`}>{pkg.title}</h3>
      <p className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900" data-testid={`package-price-${pkg.package_id}`}>{rupiah(pkg.price)}</p>
      <p className="mt-1 flex items-center gap-1.5 text-xs text-stone-500"><Clock className="h-3.5 w-3.5" /> {pkg.duration}</p>
      <p className="mt-3 line-clamp-2 text-sm text-stone-600">{pkg.description}</p>
      <ul className="mt-3 flex-1 space-y-1.5">
        {pkg.includes.slice(0, 4).map((i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-stone-600"><Check className="mt-0.5 h-4 w-4 shrink-0 text-teal-600" /> {i}</li>
        ))}
      </ul>
      {canBook && (
        <Button asChild className="mt-5 rounded-xl bg-teal-700 hover:bg-teal-800" data-testid={`package-book-button-${pkg.package_id}`}>
          <Link to={`/pesan-paket/${pkg.package_id}`}>Pesan Sekarang</Link>
        </Button>
      )}
    </div>
  </div>
);
